import { BANNER_PORTAL_NODE_ID } from "../constants"

export function GlobalBannerContainer() {
    return <div id={BANNER_PORTAL_NODE_ID}></div>
}
